import { CloseIcon } from '../../../assets/icons/Svg'
import { ProductSummary } from '../../../features/package/packageInterface';
import ClientPackageDetailsTHead from '../../common/theads/ClientPackageDetailsTHead';
import ClientPackageDetailsTBody from '../../common/tbody/ClientPackageDetailsTBody';

interface ViewClientAvailPackageProductProps {
    product: ProductSummary[] | null
    onClose: () => void;
    isLoading: boolean;
    isError: boolean;
    errormessage: string;
}

export default function ViewClientAvailPackageProduct({ isLoading, isError, errormessage, product, onClose }: ViewClientAvailPackageProductProps) {

    return (
        <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[102] overflow-hidden">
            <div className="relative w-[90vw] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75vw] lg:max-w-[60vw] lg:mx-auto overflow-hidden">
                <div className="flex flex-col w-full min-h-[50dvh] max-h-[80dvh] overflow-hidden">
                    <div className="flex flex-col py-5 space-y-3 h-full">
                        <div className="flex justify-between items-center py-1">
                            <div>
                                <p className="text-sm font-semibold leading-tight text-slate-900">Products</p>
                                <p className="text-sm text-slate-500 mt-1">View available products.</p>
                            </div>
                            <button onClick={onClose} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center" >
                                <CloseIcon />
                            </button>
                        </div>
                        <div className='flex-1 overflow-hidden bg-white rounded border'>
                            <div className='overflow-y-auto h-full'>
                                <table className='min-w-max w-full'>
                                    <ClientPackageDetailsTHead/>
                                    <ClientPackageDetailsTBody
                                        prod={product}
                                        isLoading={isLoading}
                                        isError={isError}
                                        errorMessage={errormessage}
                                        isEmpty={product?.length === 0}
                                    />
                                </table>
                                </div>
                            <div/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
